export const SET_APPLE_VALUE = 'SET_APPLE_VALUE'
export const setValueAction = (appleState: any) => {
    return {
        type: SET_APPLE_VALUE,
        payload: {
            applealbumid: appleState.applealbumid,
            applealbumname: appleState.applealbumname,
        }
    }
}   